import * as runtime from '@/api/runtime'
import {
  BatchReserveCollectionListRequest,
  BatchReserveCollectionListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchReserveCollectionListCondition,
  BatchReserveCollectionListConditionFromJSON
} from '@/api/models/batch/BatchReserveCollectionListCondition'

/**
 * 帳票作成
 */
export class BatchReserveCollectionListApi extends runtime.BaseAPI {
  async return(request: BatchReserveCollectionListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/reserve/reserve-collection-list`,
      BatchReserveCollectionListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReserveCollectionListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReserveCollectionListConditionFromJSON(jsonValue)
    ).value()
  }
}
